import { formatDataForSelectDropdown } from '@nile/components/src';
import { COMMON_CONSTANTS } from '@nile/components/src/Constants/Common';
import { AccountClient, apiResolver, GET_ALL_TECHS_NEW } from '@nile/graphql';

const getStatusTranslationKeys = () => ({
  'In Progress': 'project.task.status.inProgress',
  'Planned': 'project.task.status.planned',
  'Completed': 'app.common.completed',
  'Cancelled': 'common.cancelled',
  'Blocked': 'project.task.status.blocked',
  'Deleted': 'app.common.deleted'
});


function getLabel(name) {
  switch (name) {   
    case 'task':
      return 'entity.task';
    case 'milestone':
      return 'entity.milestone';
    default:
      return name;
  }
}

const isSortable = (col,projectListMeta) => {
  if (!projectListMeta) return false;
  const { sortAttributes } = projectListMeta;
  if (sortAttributes?.includes(col.name)) {
    return true;
  }
  return false;
};

const isFilterable = (col,projectListMeta) => {
  if (!projectListMeta) return false;
  const { searchAttributes } = projectListMeta;
  if (searchAttributes?.includes(col.name)) {
    return true;
  }
  return false;
};

const getAccessor = (col) => {
  switch (col.name) {
    case 'owner':
      return 'owner.name';
    case 'client':
      return 'client.name';
    case 'site':
      return 'site.name';
    default:
      return col.name;
  }
};

const getType = (col) => {
  if (col.dataType === 'number') {
    return 'Number';
  }
  switch (col.name) {
    case 'title':
      return 'Link';
    case 'status':
      return 'Badge';
    case 'owner':
      return 'Avatar';
    case 'scheduledStartDate':
    case 'dueDate':
    case 'actualEndDate':
    case 'createdTime':
      return 'DateTime';
    case 'milestone':
      return 'Milestone';
    case 'task':
      return 'Task';
    default:
      return 'Text';
  }
};

const getFieldOptions = (col) => {
  switch (col.name) {
    case 'status':
      return Object.entries(getStatusTranslationKeys()).map(([id, value]) => ({
        id,
        value
      }));
    default:
      return null;
  }
};

const getVariables = (property) => {
  switch (property.name) {
    case 'client':
    case 'site':
    case 'owner':
      return {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      };
    default:
      return null;
  }
};
const getQuery = (f) => {
  switch (f.name) {
    case 'owner':
      return GET_ALL_TECHS_NEW;
    default:
      return '';
  }
};

const getAsyncOptions = (property) => {
  return { client: AccountClient, query: getQuery(property) };
};

const checkDynamicQuery = (f) => {
  switch (f.name) {
    case 'client':
    case 'site':
    case 'status':
      return true;
    default:
      return false;
  }
};

const getDynamicQuery = (f) => {
  const resolverModule = 'Project';
  let query, client, variables;
  if (f.name === 'client') {
    variables = {
      listInfo: {
        sort: {
          attribute: 'name',
          order: 'ASC'
        }
      }
    };
  }
  switch (f.name) {
    default:
      query = apiResolver[resolverModule][f.name]?.api;
      client = apiResolver[resolverModule][f.name]?.client;
      variables =
        variables || apiResolver?.[resolverModule]?.[f?.name]?.variables;
      return client.query({
        query: query,
        variables: variables
      });
  }
};

const generateOptions = (f, data, params) => {
  let allValues = [];
  switch (f.name) {
    case 'client':
      allValues = formatDataForSelectDropdown(data.getClientList.clients, {
        name: 'accountId'
      });
      break;
    case 'site':
      allValues = formatDataForSelectDropdown(
        data?.getClientSiteList?.sites?.filter((site) =>
          params?.accountId ? site.account.accountId === params.accountId : true
        ),
        { name: 'siteId' }
      );
      break;
    case 'status':
      allValues = formatDataForSelectDropdown(data.getWorkStatuses);
      break;
    default:
      allValues = [];
  }
  return allValues;
};

function getNameKey(property) {
  switch (property.name) {
    case 'owner':
      return 'getTechnicianList';
    default:
      return '';
  }
}

const fetchValues = async (client, query, params) => {
  const attribute = 'name';
  const nameKey = getNameKey(params.property);
  const variables = {
      listInfo: {
        condition: {
          joinOperator: 'AND',
          operands: [
            {
              attribute: attribute || 'name',
              operator: 'startsWith',
              value: params.inputValue
            }
          ]
        }
      }
  };
  const res = await client.query({
    query: query,
    variables: COMMON_CONSTANTS.IS_INSIDE_INPUT_VARIABLES[nameKey]
      ? { input: variables }
      : variables
  });
  const allOptions = res?.data?.[nameKey]
    ? res.data[nameKey].userList.map((el) => {
        return {
          name: `${el[attribute]}`,
          value: `${el[attribute]}`,
          label: `${el[attribute]}`
        };
      })
    : [];

  return allOptions;
};

export {
  isFilterable,
  isSortable,
  getAccessor,
  getType,
  getFieldOptions,
  getVariables,
  getQuery,
  getDynamicQuery,
  checkDynamicQuery,
  generateOptions,
  fetchValues,
  getAsyncOptions,
  getLabel,
  getStatusTranslationKeys
};
